import React from "react";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import Creatable from "react-select/creatable";
import FormField from "../FormField";

interface Props {
    informationMode: string;
    informationModes: any[];
    isEditMode: boolean;
    isConsult: boolean;
    inputInformationMode: boolean;
    isNameExist: boolean;
    onChange: (e: any) => void;
}

const isValidNewOptionFalse = () => false;

const InformationModeField = React.memo(
    ({
        informationMode,
        informationModes,
        isEditMode,
        isConsult,
        inputInformationMode,
        isNameExist,
        onChange,
    }: Props) => {
        const { t } = useTranslation();

        const value =
            informationMode === ""
                ? null
                : { label: informationMode, value: informationMode };

        return (
            <FormField
                label={t("Mode of information")}
                required
                disabled={isConsult}
                error={inputInformationMode}
                errorMessage={t("Please select a mode of information")}
                secondError={isNameExist}
                secondErrorMessage={t(
                    "The combination mode of information , support of sale already exists"
                )}
            >
                <Creatable
                    className={classnames("mdi_inp_FRinformationModes", {
                        invalid__clz: inputInformationMode || isNameExist,
                        "not-allowed-input__clz": isEditMode,
                    })}
                    isClearable
                    options={informationModes}
                    onChange={onChange}
                    value={value}
                    placeholder={`${t("Select")}...`}
                    maxMenuHeight={150}
                    isValidNewOption={isValidNewOptionFalse}
                    autoFocus={!isEditMode && !isConsult}
                />
            </FormField>
        );
    }
);

InformationModeField.displayName = "InformationModeField";
export default InformationModeField;
